const { EncryptStorage } = require("encrypt-storage");
export const encryptStorage = EncryptStorage(
  "d4c8266c-c2af-4946-845c-6a51ca88ca95",
  {
    prefix: "@prefix",
  }
);
